import React from 'react';
import { NamedLink } from '../../components';
import IconMessage from '../../components/IconMessage/IconMessage';
import IconHeart from '../../components/IconHeart/IconHeart';
import IconSearch from '../../components/IconSearch/IconSearch';
import css from './GlobalBottomNavMobile.module.css';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { currentUserSelector } from '../../ducks/user.duck';
import { getUserType } from '../../util/userDataExtraction';
import { UserType } from '../../util/enums';
import { selectIsAuthenticated } from '../../ducks/auth.duck';
import Icons from '../../components/Icons/Icons';

function GlobalBottomNavMobile() {
  const currentUser = useSelector(currentUserSelector);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const userType = getUserType(currentUser);
  const notificationCount = 0;
  const notificationDot = notificationCount >= 0 ? <div className={css.notificationDot} /> : null;
  return (
    <div className={css.bottomNavbar}>
      <NamedLink name="SearchPage">
        <IconSearch />
        <span>
          <FormattedMessage id="GlobalBottomNavMobile.explore" />
        </span>
      </NamedLink>

      <NamedLink rel="nofollow" name="FavoritesPage" className={css.navLink}>
        <IconHeart />
        <span>
          <FormattedMessage id="GlobalBottomNavMobile.wishlist" />
        </span>
      </NamedLink>

      {isAuthenticated ? (
        <NamedLink
          rel="nofollow"
          name={userType === UserType.SERVICE_PROVIDERS ? 'ManageListingsPage' : 'InboxPage'}
          params={{ tab: 'sales' }}
        >
          <Icons name="myListings" />
          <span>
            <FormattedMessage
              id={
                userType === UserType.SERVICE_PROVIDERS
                  ? 'GlobalBottomNavMobile.myListings'
                  : 'GlobalBottomNavMobile.bookings'
              }
            />
          </span>
          {notificationDot}
        </NamedLink>
      ) : (
        <NamedLink rel="nofollow" name="NewListingPage">
          <Icons name="myListings" />
          <span>
            <FormattedMessage id="GlobalBottomNavMobile.addListing" defaultMessage="Add Listing" />
          </span>
        </NamedLink>
      )}

      {isAuthenticated ? (
        <NamedLink rel="nofollow" name="InboxPage" params={{ tab: 'sales' }}>
          <IconMessage />
          <span>
            <FormattedMessage id="GlobalBottomNavMobile.messages" />
          </span>
        </NamedLink>
      ) : (
        <NamedLink rel="nofollow" name="FAQPage">
          <Icons name="faqs" />
          <span>
            <FormattedMessage id="GlobalBottomNavMobile.faqs" />
          </span>
        </NamedLink>
      )}

      {isAuthenticated ? (
        <NamedLink rel="nofollow" name="ProfileSettingsPage">
          <Icons name="profileSettings" />
          <span>
            <FormattedMessage id="GlobalBottomNavMobile.profile" />
          </span>
        </NamedLink>
      ) : (
        <NamedLink rel="nofollow" name="LoginPage">
          <Icons name="profileSettings" />
          <span>
            <FormattedMessage id="GlobalBottomNavMobile.login" defaultMessage="Login" />
          </span>
        </NamedLink>
      )}
    </div>
  );
}

export default GlobalBottomNavMobile;
